import { createFileRoute } from '@tanstack/react-router'

import { BackofficeAdminCpmsPage as PlatformAdminCpmsPage } from '../../../../../components/pages/backoffice/platform/platform-admin-cpms-page.tsx'
import { PermissionChecker } from '../../../../../components/templates/permission-checker.tsx'

export const Route = createFileRoute('/bo/contracts/$subscriptionId/cpms')({
  component: function Component() {
    const { subscriptionId } = Route.useParams()
    return (
      <PermissionChecker requiredPermissions={['contract.cpms']}>
        <PlatformAdminCpmsPage subscriptionId={subscriptionId} />
      </PermissionChecker>
    )
  },
})
